/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  ClaimCheckpointBody,
  ClaimCheckpointResponse,
  ClaimRewardResponse,
  FormError,
  PlayableMissionResponse,
  RedeemActivationCodeBody,
  RedeemActivationCodeResponse,
  ScanActivationQrBody,
  ScanActivationQrResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    ClaimCheckpointBodyFromJSON,
    ClaimCheckpointBodyToJSON,
    ClaimCheckpointResponseFromJSON,
    ClaimCheckpointResponseToJSON,
    ClaimRewardResponseFromJSON,
    ClaimRewardResponseToJSON,
    FormErrorFromJSON,
    FormErrorToJSON,
    PlayableMissionResponseFromJSON,
    PlayableMissionResponseToJSON,
    RedeemActivationCodeBodyFromJSON,
    RedeemActivationCodeBodyToJSON,
    RedeemActivationCodeResponseFromJSON,
    RedeemActivationCodeResponseToJSON,
    ScanActivationQrBodyFromJSON,
    ScanActivationQrBodyToJSON,
    ScanActivationQrResponseFromJSON,
    ScanActivationQrResponseToJSON,
} from '../models/index';

export interface CreateActivationsActivationIdCappedSeenRequest {
    activationId: string;
}

export interface CreateActivationsActivationIdClaimRequest {
    activationId: string;
}

export interface CreateActivationsActivationIdObjectivesObjectiveIdClaimCheckpointRequest {
    activationId: string;
    objectiveId: string;
    claimCheckpointBody: ClaimCheckpointBody;
}

export interface CreateActivationsActivationIdRedeemCodeRequest {
    activationId: string;
    redeemActivationCodeBody: RedeemActivationCodeBody;
}

export interface CreateActivationsActivationIdScanQrRequest {
    activationId: string;
    scanActivationQrBody: ScanActivationQrBody;
}

export interface GetMissionsPlayableRequest {
    utmSource: string;
    externalGameId?: string;
    activationTypes?: string;
}

/**
 * MissionsApi - interface
 * 
 * @export
 * @interface MissionsApiInterface
 */
export interface MissionsApiInterface {
    /**
     * Mark the capped-state message as seen for the authenticated user. Releases the Blitz slot on next /exists poll.
     * @param {string} activationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissionsApiInterface
     */
    createActivationsActivationIdCappedSeenRaw(requestParameters: CreateActivationsActivationIdCappedSeenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Mark the capped-state message as seen for the authenticated user. Releases the Blitz slot on next /exists poll.
     */
    createActivationsActivationIdCappedSeen(requestParameters: CreateActivationsActivationIdCappedSeenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Claim reward for a completed activation
     * @param {string} activationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissionsApiInterface
     */
    createActivationsActivationIdClaimRaw(requestParameters: CreateActivationsActivationIdClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimRewardResponse>>;

    /**
     * Claim reward for a completed activation
     */
    createActivationsActivationIdClaim(requestParameters: CreateActivationsActivationIdClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimRewardResponse>;

    /**
     * Claim a checkpoint reward for an objective
     * @param {string} activationId 
     * @param {string} objectiveId 
     * @param {ClaimCheckpointBody} claimCheckpointBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissionsApiInterface
     */
    createActivationsActivationIdObjectivesObjectiveIdClaimCheckpointRaw(requestParameters: CreateActivationsActivationIdObjectivesObjectiveIdClaimCheckpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimCheckpointResponse>>;

    /**
     * Claim a checkpoint reward for an objective
     */
    createActivationsActivationIdObjectivesObjectiveIdClaimCheckpoint(requestParameters: CreateActivationsActivationIdObjectivesObjectiveIdClaimCheckpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimCheckpointResponse>;

    /**
     * Redeem a promo code for an activation CODE_ENTRY objective
     * @param {string} activationId 
     * @param {RedeemActivationCodeBody} redeemActivationCodeBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissionsApiInterface
     */
    createActivationsActivationIdRedeemCodeRaw(requestParameters: CreateActivationsActivationIdRedeemCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RedeemActivationCodeResponse>>;

    /**
     * Redeem a promo code for an activation CODE_ENTRY objective
     */
    createActivationsActivationIdRedeemCode(requestParameters: CreateActivationsActivationIdRedeemCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RedeemActivationCodeResponse>;

    /**
     * Validate a QR code scan for an activation QR_SCAN objective
     * @param {string} activationId 
     * @param {ScanActivationQrBody} scanActivationQrBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissionsApiInterface
     */
    createActivationsActivationIdScanQrRaw(requestParameters: CreateActivationsActivationIdScanQrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScanActivationQrResponse>>;

    /**
     * Validate a QR code scan for an activation QR_SCAN objective
     */
    createActivationsActivationIdScanQr(requestParameters: CreateActivationsActivationIdScanQrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScanActivationQrResponse>;

    /**
     * Get objective-based playable ad activations for partner sites. Returns BrandActivations of type PLAYABLE_AD that have catalog objectives. Rate limited: 300 requests per 5 minutes per IP. 
     * @param {string} utmSource UTM source to identify the partner (e.g., blitz)
     * @param {string} [externalGameId] Partner-specific game ID to filter by
     * @param {string} [activationTypes] Comma-separated BrandActivation types to read objectives from. Omitted defaults to PLAYABLE_AD. Objectives are not playable-ad-specific — a BRAND_CHALLENGE carries the same shape.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MissionsApiInterface
     */
    getMissionsPlayableRaw(requestParameters: GetMissionsPlayableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PlayableMissionResponse>>>;

    /**
     * Get objective-based playable ad activations for partner sites. Returns BrandActivations of type PLAYABLE_AD that have catalog objectives. Rate limited: 300 requests per 5 minutes per IP. 
     */
    getMissionsPlayable(requestParameters: GetMissionsPlayableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PlayableMissionResponse>>;

}

/**
 * 
 */
export class MissionsApi extends runtime.BaseAPI implements MissionsApiInterface {

    /**
     * Mark the capped-state message as seen for the authenticated user. Releases the Blitz slot on next /exists poll.
     */
    async createActivationsActivationIdCappedSeenRaw(requestParameters: CreateActivationsActivationIdCappedSeenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['activationId'] == null) {
            throw new runtime.RequiredError(
                'activationId',
                'Required parameter "activationId" was null or undefined when calling createActivationsActivationIdCappedSeen().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/activations/{activationId}/capped-seen`;
        urlPath = urlPath.replace(`{${"activationId"}}`, encodeURIComponent(String(requestParameters['activationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mark the capped-state message as seen for the authenticated user. Releases the Blitz slot on next /exists poll.
     */
    async createActivationsActivationIdCappedSeen(requestParameters: CreateActivationsActivationIdCappedSeenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createActivationsActivationIdCappedSeenRaw(requestParameters, initOverrides);
    }

    /**
     * Claim reward for a completed activation
     */
    async createActivationsActivationIdClaimRaw(requestParameters: CreateActivationsActivationIdClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimRewardResponse>> {
        if (requestParameters['activationId'] == null) {
            throw new runtime.RequiredError(
                'activationId',
                'Required parameter "activationId" was null or undefined when calling createActivationsActivationIdClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/activations/{activationId}/claim`;
        urlPath = urlPath.replace(`{${"activationId"}}`, encodeURIComponent(String(requestParameters['activationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimRewardResponseFromJSON(jsonValue));
    }

    /**
     * Claim reward for a completed activation
     */
    async createActivationsActivationIdClaim(requestParameters: CreateActivationsActivationIdClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimRewardResponse> {
        const response = await this.createActivationsActivationIdClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Claim a checkpoint reward for an objective
     */
    async createActivationsActivationIdObjectivesObjectiveIdClaimCheckpointRaw(requestParameters: CreateActivationsActivationIdObjectivesObjectiveIdClaimCheckpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimCheckpointResponse>> {
        if (requestParameters['activationId'] == null) {
            throw new runtime.RequiredError(
                'activationId',
                'Required parameter "activationId" was null or undefined when calling createActivationsActivationIdObjectivesObjectiveIdClaimCheckpoint().'
            );
        }

        if (requestParameters['objectiveId'] == null) {
            throw new runtime.RequiredError(
                'objectiveId',
                'Required parameter "objectiveId" was null or undefined when calling createActivationsActivationIdObjectivesObjectiveIdClaimCheckpoint().'
            );
        }

        if (requestParameters['claimCheckpointBody'] == null) {
            throw new runtime.RequiredError(
                'claimCheckpointBody',
                'Required parameter "claimCheckpointBody" was null or undefined when calling createActivationsActivationIdObjectivesObjectiveIdClaimCheckpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/activations/{activationId}/objectives/{objectiveId}/claim-checkpoint`;
        urlPath = urlPath.replace(`{${"activationId"}}`, encodeURIComponent(String(requestParameters['activationId'])));
        urlPath = urlPath.replace(`{${"objectiveId"}}`, encodeURIComponent(String(requestParameters['objectiveId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClaimCheckpointBodyToJSON(requestParameters['claimCheckpointBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimCheckpointResponseFromJSON(jsonValue));
    }

    /**
     * Claim a checkpoint reward for an objective
     */
    async createActivationsActivationIdObjectivesObjectiveIdClaimCheckpoint(requestParameters: CreateActivationsActivationIdObjectivesObjectiveIdClaimCheckpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimCheckpointResponse> {
        const response = await this.createActivationsActivationIdObjectivesObjectiveIdClaimCheckpointRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Redeem a promo code for an activation CODE_ENTRY objective
     */
    async createActivationsActivationIdRedeemCodeRaw(requestParameters: CreateActivationsActivationIdRedeemCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RedeemActivationCodeResponse>> {
        if (requestParameters['activationId'] == null) {
            throw new runtime.RequiredError(
                'activationId',
                'Required parameter "activationId" was null or undefined when calling createActivationsActivationIdRedeemCode().'
            );
        }

        if (requestParameters['redeemActivationCodeBody'] == null) {
            throw new runtime.RequiredError(
                'redeemActivationCodeBody',
                'Required parameter "redeemActivationCodeBody" was null or undefined when calling createActivationsActivationIdRedeemCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/activations/{activationId}/redeem-code`;
        urlPath = urlPath.replace(`{${"activationId"}}`, encodeURIComponent(String(requestParameters['activationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RedeemActivationCodeBodyToJSON(requestParameters['redeemActivationCodeBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RedeemActivationCodeResponseFromJSON(jsonValue));
    }

    /**
     * Redeem a promo code for an activation CODE_ENTRY objective
     */
    async createActivationsActivationIdRedeemCode(requestParameters: CreateActivationsActivationIdRedeemCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RedeemActivationCodeResponse> {
        const response = await this.createActivationsActivationIdRedeemCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate a QR code scan for an activation QR_SCAN objective
     */
    async createActivationsActivationIdScanQrRaw(requestParameters: CreateActivationsActivationIdScanQrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScanActivationQrResponse>> {
        if (requestParameters['activationId'] == null) {
            throw new runtime.RequiredError(
                'activationId',
                'Required parameter "activationId" was null or undefined when calling createActivationsActivationIdScanQr().'
            );
        }

        if (requestParameters['scanActivationQrBody'] == null) {
            throw new runtime.RequiredError(
                'scanActivationQrBody',
                'Required parameter "scanActivationQrBody" was null or undefined when calling createActivationsActivationIdScanQr().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/activations/{activationId}/scan-qr`;
        urlPath = urlPath.replace(`{${"activationId"}}`, encodeURIComponent(String(requestParameters['activationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ScanActivationQrBodyToJSON(requestParameters['scanActivationQrBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScanActivationQrResponseFromJSON(jsonValue));
    }

    /**
     * Validate a QR code scan for an activation QR_SCAN objective
     */
    async createActivationsActivationIdScanQr(requestParameters: CreateActivationsActivationIdScanQrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScanActivationQrResponse> {
        const response = await this.createActivationsActivationIdScanQrRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get objective-based playable ad activations for partner sites. Returns BrandActivations of type PLAYABLE_AD that have catalog objectives. Rate limited: 300 requests per 5 minutes per IP. 
     */
    async getMissionsPlayableRaw(requestParameters: GetMissionsPlayableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PlayableMissionResponse>>> {
        if (requestParameters['utmSource'] == null) {
            throw new runtime.RequiredError(
                'utmSource',
                'Required parameter "utmSource" was null or undefined when calling getMissionsPlayable().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['utmSource'] != null) {
            queryParameters['utmSource'] = requestParameters['utmSource'];
        }

        if (requestParameters['externalGameId'] != null) {
            queryParameters['externalGameId'] = requestParameters['externalGameId'];
        }

        if (requestParameters['activationTypes'] != null) {
            queryParameters['activationTypes'] = requestParameters['activationTypes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/missions/playable`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PlayableMissionResponseFromJSON));
    }

    /**
     * Get objective-based playable ad activations for partner sites. Returns BrandActivations of type PLAYABLE_AD that have catalog objectives. Rate limited: 300 requests per 5 minutes per IP. 
     */
    async getMissionsPlayable(requestParameters: GetMissionsPlayableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PlayableMissionResponse>> {
        const response = await this.getMissionsPlayableRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
